export const FETCH_PDF_REQUEST = "FETCH_PDF_REQUEST";
export const FETCH_PDF_SUCCESS = "FETCH_PDF_SUCCESS";
export const FETCH_PDF_FAILURE = "FETCH_PDF_FAILURE";

export const CREATE_AGREEMENT_REQUEST = "CREATE_AGREEMENT_REQUEST";
export const CREATE_AGREEMENT_SUCCESS = "CREATE_AGREEMENT_SUCCESS";
export const CREATE_AGREEMENT_FAILURE = "CREATE_AGREEMENT_FAILURE";

export const CHANGE_STATUS_REQUEST = "CHANGE_STATUS_REQUEST";
export const CHANGE_STATUS_SUCCESS = "CHANGE_STATUS_SUCCESS";
export const CHANGE_STATUS_FAILURE = "CHANGE_STATUS_FAILURE";

export const DECLINE_AGREEMENT_REQUEST = "DECLINE_AGREEMENT_REQUEST";
export const DECLINE_AGREEMENT_SUCCESS = "DECLINE_AGREEMENT_SUCCESS";
export const DECLINE_AGREEMENT_FAILURE = "DECLINE_AGREEMENT_FAILURE";

export const FETCH_ADOBE_DOCUMENT_REQUEST = "FETCH_ADOBE_DOCUMENT_REQUEST";
export const FETCH_ADOBE_DOCUMENT_UNSIGNED_SUCCESS =
  "FETCH_ADOBE_DOCUMENT_UNSIGNED_SUCCESS";
export const FETCH_ADOBE_DOCUMENT_SIGNED_SUCCESS =
  "FETCH_ADOBE_DOCUMENT_SIGNED_SUCCESS";
export const FETCH_ADOBE_DOCUMENT_FAILURE = "FETCH_ADOBE_DOCUMENT_FAILURE";

export const INCREMENT_INTERVAL_COUNTER = "INCREMENT_INTERVAL_COUNTER";
